module.exports = __webpack_public_path__ + "img/close-icon.4290f634.svg";